import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportRoutingModule } from './report-routing.module';
import { ReportMachineStatusComponent } from './components/report-machine-status/report-machine-status.component';
import { CoreModule } from '../core/core.module';
import { Common2Module } from 'projects/common/src/app/app.module';
import { FormsModule } from '@angular/forms';
import { ReportMessengerComponent } from './components/report-messenger/report-messenger.component';
import { PieChartComponent } from './components/report-machine-status/pie-chart/pie-chart.component';
import { SubstateTableComponent } from './components/report-machine-status/substate-table/substate-table.component';
import { SubstateModalComponent } from './components/report-machine-status/substate-modal/substate-modal.component';
import { StatusFamilyTableComponent } from './components/report-machine-status/status-family-table/status-family-table.component';
import { ChecklistShellComponent } from './components/report-checklist/checklist-shell/checklist-shell.component';
import { ChecklistTableComponent } from './components/report-checklist/checklist-table/checklist-table.component';
import { ChecklistModalComponent } from './components/report-checklist/checklist-modal/checklist-modal.component';
import { MarineShellComponent } from './components/report-marine/marine-shell/marine-shell.component';
import { DetailsTableMarineComponent } from './components/report-marine/details-table-marine/details-table-marine.component';
import { LoopByOperatorShellComponent } from './components/loop-by-operator-shell/loop-by-operator-shell.component';
import { LoopByOperatorFilterResultComponent } from './components/common/loop-by-operator-filter-result/loop-by-operator-filter-result.component';
import { TransferByShiftCardsComponent } from './components/common/transfer-by-shift-cards/transfer-by-shift-cards.component';
import { TransferByMachineShiftTableComponent } from './components/common/transfer-by-machine-shift-table/transfer-by-machine-shift-table.component';
import { LoopByMachineShellComponent } from './components/loop-by-machine-shell/loop-by-machine-shell.component';
import { LoopByMachineTruckShellComponent } from './components/loop-by-machine-truck-shell/loop-by-machine-truck-shell.component';
import { LoopByOperatorTruckShellComponent } from './components/loop-by-operator-truck-shell/loop-by-operator-truck-shell.component';
import { ReportDrillingComponent } from './components/report-drilling/report-drilling.component';
import { TotalDepthComponent } from './components/report-drilling/total-depth/total-depth.component';
import { ReportTransitComponent } from './components/report-transit/report-transit.component';
import { ReportFrontsComponent } from './components/report-fronts/report-fronts.component';
import { ReportDrillHcmComponent } from './components/report-drill-hcm/report-drill-hcm.component';
import { TotalDepthHcmComponent } from './components/report-drill-hcm/total-depth-hcm/total-depth-hcm.component';
import { ReportExplosiveComponent } from './components/report-explosive/report-explosive.component';
import { ReportExplosiveModalComponent } from './components/report-explosive/report-explosive-modal/report-explosive-modal.component';
import { ReportSpotConditionComponent } from './components/report-spot-condition/report-spot-condition.component';
import { ReportVitalSignsComponent } from './components/report-vital-signs/report-vital-signs.component';
import { ReportZoneHistoryComponent } from './components/report-zone-history/report-zone-history.component';
import { ReportComputerHistoryComponent } from './components/report-computer-history/report-computer-history.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReportInterceptorService } from './services/report-interceptor';
import { ReportDownloadHistoryComponent } from './components/report-download-history/report-download-history.component';
import { ReportFrontModalComponent } from './components/report-fronts/report-front-modal/report-front-modal.component';
import { ReportVitalSignsHourometerComponent } from './components/report-vital-signs-hourmeter/report-vital-signs-hourmeter.component';
import { ReportHourmeterFuelComponent } from './components/report-hourmeter-fuel/report-hourmeter-fuel.component';
import { ReportCartirComponent } from './components/report-cartir/report-cartir.component';
import { LoopEmbeddedByMachineTruckComponent } from './components/loop-embedded-by-machine-truck/loop-embedded-by-machine-truck.component';
import { ModalReportComponent } from './components/common/modal-report/modal-report.component';
import { ReportCartirVsProductionComponent } from './components/report-cartir-vs-production/report-cartir-vs-production.component';
import { ReportCasComponent } from './components/report-cas/report-cas.component';
import { ReportMonthlyStatePerOperatorComponent } from './components/report-monthly-state-per-operator/report-monthly-state-per-operator.component';
import { ReportOperationalDisciplineComponent } from './components/report-operational-discipline/report-operational-discipline.component';
import { ReportOperationalDisciplineModalComponent } from './components/report-operational-discipline/report-operational-discipline-modal/report-operational-discipline-modal.component';

@NgModule({
  declarations: [
    ReportMachineStatusComponent,
    ReportMessengerComponent,
    PieChartComponent,
    SubstateTableComponent,
    SubstateModalComponent,
    StatusFamilyTableComponent,
    ChecklistShellComponent,
    ChecklistTableComponent,
    ChecklistModalComponent,
    MarineShellComponent,
    DetailsTableMarineComponent,
    LoopByOperatorShellComponent,
    LoopByOperatorFilterResultComponent,
    TransferByShiftCardsComponent,
    TransferByMachineShiftTableComponent,
    LoopByMachineShellComponent,
    LoopByOperatorTruckShellComponent,
    ReportTransitComponent,
    LoopByOperatorTruckShellComponent,
    LoopByMachineTruckShellComponent,
    LoopByOperatorTruckShellComponent,
    ReportDrillingComponent,
    TotalDepthComponent,
    ReportFrontsComponent,
    ReportFrontModalComponent,
    LoopByMachineTruckShellComponent,
    ReportDrillHcmComponent,
    TotalDepthHcmComponent,
    ReportExplosiveComponent,
    ReportExplosiveModalComponent,
    ReportSpotConditionComponent,
    ReportVitalSignsComponent,
    ReportZoneHistoryComponent,
    ReportComputerHistoryComponent,
    ReportDownloadHistoryComponent,
    ReportVitalSignsHourometerComponent,
    ReportHourmeterFuelComponent,
    ReportCartirComponent,
    LoopEmbeddedByMachineTruckComponent,
    ModalReportComponent,
    ReportCartirVsProductionComponent,
    ReportCasComponent,
    ReportMonthlyStatePerOperatorComponent,
    ReportOperationalDisciplineComponent,
    ReportOperationalDisciplineModalComponent,
  ],
  imports: [CommonModule, ReportRoutingModule, CoreModule, Common2Module.forRoot(), FormsModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ReportInterceptorService,
      multi: true,
    },
  ],
  exports: [],
})
export class ReportModule {}
